import React from 'react'

const Opportunities = () => {
    return (
        <>

            <section className="counter-section section-padding" style={{marginTop:"-40px"}}>
                <div className="snake-shape float-bob-y">
                    <img src="assets/img/counter/snake.png" alt="shape-img" />
                </div>
                <div className="sun-shape float-bob-x">
                    <img src="assets/img/counter/sun.png" alt="shape-img" />
                </div>
                <div className="counter-bg" />
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".2s">
                            <div className="counter-items">
                                <div className="icon">
                                    <img src="assets/img/counter/icon1.svg" alt="icon-image" />
                                </div>
                                <div className="counter-box">
                                    <div className="count">
                                        <h3 className="odometer" data-count={12}>0</h3>
                                        <span className="plus">+</span>
                                    </div>
                                    <p>Our Teachers</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".4s">
                            <div className="counter-items">
                                <div className="icon">
                                    <img src="assets/img/counter/icon2.svg" alt="icon-image" />
                                </div>
                                <div className="counter-box">
                                    <div className="count">
                                        <h3 className="odometer" data-count="13">0</h3>
                                        <span className="plus">+</span>
                                    </div>
                                    <p>Our Classroom</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".6s">
                            <div className="counter-items">
                                <div className="icon">
                                    <img src="assets/img/counter/icon3.svg" alt="icon-image" />
                                </div>
                                <div className="counter-box">
                                    <div className="count">
                                        <h3 className="odometer" data-count={21}>0</h3>
                                        <span className="plus">+</span>
                                    </div>
                                    <p>Year of Experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".8s">
                            <div className="counter-items border-none">
                                <div className="icon">
                                    <img src="assets/img/counter/icon4.svg" alt="icon-image" />
                                </div>
                                <div className="counter-box">
                                    <div className="count">
                                        <h3 className="odometer" data-count="955">0</h3>
                                        <span className="plus">+</span>
                                    </div>
                                    <p>Our Students</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Opportunities